import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function PainSection() {
  const painPoints = ['Dormís mal. Te despertás con calor y cansancio.', 'Tu cuerpo cambió sin avisar. Comés igual y te inflamás / subís fácil.', 'Niebla mental. Te cuesta concentrarte y te olvidás de cosas simples.', 'Energía baja. Todo te agota y a la tarde te caés.'];
  return <section className="bg-gradient-section py-12 md:py-16 px-4 md:px-8" data-id="element-253" data-mp="2l8m0xmhwypzz">
      <div className="max-w-3xl mx-auto space-y-14" data-id="element-254" data-mp="2l6j2ce2p3ojn">
        {/* Eyebrow title */}
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center uppercase tracking-[0.3em] text-[#C8A870] font-semibold text-[13px]" data-id="element-255" data-mp="2q0dnzn1v2dld">
          Una historia que podría ser la tuya
        </motion.p>

        {/* Story Block */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="card-premium p-7 md:p-12 relative overflow-hidden" data-id="element-256" data-mp="27anqutamlfqa">
          <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-gradient-to-b from-transparent via-gold/60 to-transparent" data-id="element-257" data-mp="5faoxbz9hqyh" />

          <div className="space-y-6 pl-3 md:pl-6" data-id="element-258" data-mp="ewr0mrdjxe6">
            <p className="italic text-[19px] md:text-[22px] text-foreground/80 font-body leading-[1.7]" data-id="element-259" data-mp="38xkr6qwwapnl">
              María Elena tenía 49 años. Comía bien, caminaba, dormía temprano.
            </p>

            <p className="italic text-[19px] md:text-[22px] text-foreground/80 font-body leading-[1.7]" data-id="element-260" data-mp="3indznj1qqonm">
              Pero algo ya no era igual. Su cintura cambió. Se despertaba
              cansada. Y había días en los que no terminaba de sentirse ella
              misma.
            </p>

            <p className="font-semibold italic text-[20px] md:text-[24px] text-[#F0E8D8] font-body leading-[1.55] pt-1" data-id="element-261" data-mp="2l5x98yhm2oxg">
              "Durante mucho tiempo creyó que necesitaba esforzarse más. Hasta
              que entendió algo: No estaba fallando. Estaba atravesando una
              transición". Y las estrategias de antes ya no alcanzaban.
            </p>

            <div className="divider-fine w-full !mt-8" data-id="element-262" data-mp="12uyxl3tqsdmc" />

            <p className="md:text-[16px] text-foreground/55 font-body pt-2 text-[16px]" data-id="element-263" data-mp="12up2j1tubg9s">
              Por eso necesitaba algo diferente: una forma de acompañar esta
              etapa sin exigirse más.
            </p>

            <p className="text-[#C8A870] font-semibold md:text-[17px] text-[17px] font-body" data-id="element-264" data-mp="b5vtbo1uv39p">
              Eso es lo que propone H.E.R.
            </p>
          </div>
        </motion.div>

        {/* Pain Points */}

        {/* Closing */}
      </div>
    </section>;
}